<div class="container">
  <div class="col-12 text-center">
    <div class="title"><img src="/logo.png" alt="" /></div>
    <div class="subTitle">Coming Soon...</div>
  </div>
</div>
